module.exports = {
    "Empty": `Vazio`
};


//# sourceMappingURL=pt-PT.main.js.map
